const updates = [
  {
    time: '14:32',
    tag: '爆料',
    title: '某顶流男星被拍到深夜与神秘女子同回住所',
    hot: true,
  },
  {
    time: '13:18',
    tag: '综艺',
    title: '《乘风破浪》新一季嘉宾名单疑似曝光引热议',
    hot: true,
  },
  {
    time: '11:45',
    tag: '影视',
    title: '国产科幻大片定档国庆，预告片播放量破2亿',
    hot: false,
  },
  {
    time: '10:20',
    tag: '音乐',
    title: '知名乐队主唱宣布单飞，粉丝反应两极分化',
    hot: true,
  },
  {
    time: '09:05',
    tag: '网红',
    title: '千万粉美食博主翻车，合作品牌紧急解约',
    hot: false,
  },
  {
    time: '08:30',
    tag: '时尚',
    title: '国际时装周中国明星造型大盘点，谁赢了？',
    hot: false,
  },
  {
    time: '07:15',
    tag: '电竞',
    title: 'LPL夏季赛总决赛门票开售，黄牛价格翻五倍',
    hot: true,
  },
  {
    time: '06:00',
    tag: '国际',
    title: '好莱坞巨星新片拍摄现场发生意外，剧组停工',
    hot: false,
  },
  {
    time: '昨天 23:45',
    tag: '八卦',
    title: '昔日恩爱夫妻被曝已分居半年，双方暂无回应',
    hot: true,
  },
];

export default function UpdatesSection() {
  return (
    <section
      id="updates"
      className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50"
      style={{ scrollMarginTop: '80px' }}
    >
      <div className="w-full max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            实时快讯
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            最新娱乐热点，滚动更新中
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300/60"></div>

          <div className="flex flex-col gap-4">
            {updates.map((item, i) => (
              <div key={i} className="flex items-start gap-4 md:gap-6 pl-0">
                {/* Dot */}
                <div className="relative z-10 mt-1 flex-shrink-0">
                  <div
                    className={`w-3 h-3 rounded-full border-2 border-background-50 ${
                      item.hot ? 'bg-primary-500' : 'bg-secondary-400'
                    }`}
                  ></div>
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0 pb-3 border-b border-background-200/50">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-500 font-mono whitespace-nowrap">
                      {item.time}
                    </span>
                    <span className={`text-xs px-1.5 py-0.5 rounded ${
                      item.hot
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-secondary-100 text-secondary-700'
                    } whitespace-nowrap`}>
                      {item.tag}
                    </span>
                    {item.hot && (
                      <span className="text-xs text-accent-600 whitespace-nowrap">
                        <i className="ri-fire-fill"></i> 热
                      </span>
                    )}
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}